import React, { useContext, useEffect, useState } from "react"

import Swiper from "react-id-swiper"
import { TravelsContext } from "../../contexts/travels-context"
import axios from "axios"
import { sTrip } from "../../styled/blog-post/trip"
import useSiteMetadata from "../../hooks/use-site-metadata"

const Trip = ({ countryid, themeid, count: numberofitems }) => {
  const { lang } = useSiteMetadata()
  const { setState } = useContext(TravelsContext)
  const [trips, setTrips] = useState([])

  const swiperParams = {
    watchOverflow: true,
    touchReleaseOnEdges: true,
    spaceBetween: 20,
    slidesPerView: 1,
    pagination: {
      el: `.swiper-pagination`,
      type: `bullets`,
      clickable: true,
    },
    noSwiping: false,
    breakpoints: {
      600: {
        noSwipingClass: `swiper-slide`,
        noSwiping: true,
      },
    },
  }

  const getTrips = async (source, skip) => {
    await axios
      .get(
        `https://webapi.vivitravels.com/api/blog/listforpost?destinationid=16&locale=${
          lang === `it` ? `it-IT` : `en-US`
        }`,
        {
          cancelToken: source.token,
          params: {
            countryid,
            themeid,
            numberofitems,
            skip,
          },
        }
      )
      .then(res => {
        setTrips(res.data)
        setState(prevState => {
          return { ...prevState, tripCount: prevState.tripCount || 0 + res.data.length }
        })
      })
  }

  useEffect(() => {
    const source = axios.CancelToken.source()

    setState(prevState => {
      getTrips(
        source,
        prevState.travels
          .filter(t => t.countryid === countryid && t.themeid === themeid)
          .reduce((a, c) => a + parseInt(c.numberofitems, 10), 0)
      )

      return {
        ...prevState,
        travels: [...prevState.travels, { countryid, themeid, numberofitems }],
      }
    })

    return () => {
      source.cancel(`Get trips aborted!`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return trips.length ? (
    <sTrip.Wrapper>
      <sTrip.Head>{lang === `it` ? `Le nostre migliori idee di viaggio` : `Our best travel ideas`}</sTrip.Head>
      <sTrip.Swiper>
        <Swiper {...swiperParams}>
          {trips.map(trip => (
            <div key={trip.id}>
              <sTrip.Image>
                <img src={`https://gimli.freetls.fastly.net/vivitravels/content/328x217${trip.cover}`} alt={trip.title} />
              </sTrip.Image>
              <sTrip.Caption>
                <sTrip.Tag>{trip.themename}</sTrip.Tag>
                <sTrip.Title>{trip.title}</sTrip.Title>
                <sTrip.Desc>
                  {trip.countryname}: {trip.cities}
                </sTrip.Desc>
                <sTrip.Info>
                  {trip.price ? (
                    <span>
                      {lang === `it` ? (
                        <>
                          <strong>da {trip.price} €</strong> a persona |
                        </>
                      ) : (
                        <>
                          per person <strong>from {trip.price} €</strong> |
                        </>
                      )}
                    </span>
                  ) : null}
                  {trip.days ? ` ${trip.days} ${lang === `it` ? `giorni` : `days`}` : null}
                  {!trip.flightrequired ? ` | ${lang === `it` ? `No volo` : `No flight`}` : null}
                </sTrip.Info>
                <sTrip.Button href={trip.permalink} target="_blank" rel="noopener noreferrer">
                  {lang === `it` ? `Scopri` : `Discover now`}
                </sTrip.Button>
              </sTrip.Caption>
            </div>
          ))}
        </Swiper>
      </sTrip.Swiper>
    </sTrip.Wrapper>
  ) : null
}

export default Trip
